import { render, staticRenderFns } from "./header_index.vue?vue&type=template&id=2079a498&scoped=true"
import script from "./header_index.vue?vue&type=script&lang=js"
export * from "./header_index.vue?vue&type=script&lang=js"
import style0 from "./header_index.vue?vue&type=style&index=0&id=2079a498&prod&lang=css"
import style1 from "./header_index.vue?vue&type=style&index=1&id=2079a498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079a498",
  null
  
)

export default component.exports